module.exports = __webpack_public_path__ + "img/questionnaire_new.0896dc8a.png";